__turbopack_context__.v({
  "body": "_5Nst8G_body",
  "chip": "_5Nst8G_chip",
  "chipDot": "_5Nst8G_chipDot",
  "chipIcon": "_5Nst8G_chipIcon",
  "chipLabel": "_5Nst8G_chipLabel",
  "icon": "_5Nst8G_icon",
  "item": "_5Nst8G_item",
  "list": "_5Nst8G_list",
  "minimize": "_5Nst8G_minimize",
  "root": "_5Nst8G_root",
  "text": "_5Nst8G_text",
  "title": "_5Nst8G_title",
});
